module.exports = __webpack_public_path__ + "img/logoColor.d8b71988.png";